import settingsMutations from "./mutations.js";
import settingsActions from "./actions.js";
import settingsGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            settings: {},
            selectedSettingsSidemenu: "",
            externalPluginInfo: ""
        };
    },
    mutations: settingsMutations,
    actions: settingsActions,
    getters: settingsGetters,
};